import z from "zod";

export const selectCalculationFormSchema = z.object({
	calculationId: z.uuid(),
});

export type SelectCalculationFormSchema = z.infer<typeof selectCalculationFormSchema>;
